export default __webpack_public_path__ + "static/media/006.0d11f7f4.jpg";